var _rect, _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.356445,
    width: 31.802,
    height: 31.802,
    rx: 10.6007,
    fill: "#2165A2",
    fillOpacity: 0.2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.9008 16.155L23.0834 12.2373C22.8549 11.4857 22.3916 10.8271 21.7613 10.3582C21.1311 9.88935 20.3671 9.63484 19.5816 9.63208H12.22C11.4345 9.63484 10.6705 9.88935 10.0403 10.3582C9.41004 10.8271 8.94669 11.4857 8.71826 12.2373L15.9008 16.155Z",
    fill: "#2165A2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.2538 17.64C16.1456 17.699 16.0243 17.7299 15.9011 17.7299C15.7779 17.7299 15.6567 17.699 15.5485 17.64L8.53955 13.8169V19.2022C8.5407 20.178 8.92887 21.1136 9.6189 21.8036C10.3089 22.4937 11.2445 22.8818 12.2203 22.883H19.5819C20.5578 22.8818 21.4933 22.4937 22.1834 21.8036C22.8734 21.1136 23.2616 20.178 23.2627 19.2022V13.8169L16.2538 17.64Z",
    fill: "#2165A2"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.afaddf7e35fe6931f987f9b0dbf429cd.svg";
export { ForwardRef as ReactComponent };